import _ from "lodash";
import {
  FETCH_SUBSCRIPTIONS,
  FETCH_SUBSCRIPTION_ESTIMATE,
  FETCH_SUBSCRIPTION_PAYMENT_INTENT,
  FETCH_SUBSCRIPTION_CREATE,
  CLEAR_SUBSCRIPTION_CREATE,
  CLEAR_SUBSCRIPTION_ESTIMATE,
  FETCH_SUBSCRIPTION_ADDONS,
  CLEAR_LICENSES_INFO,
  FETCH_LICENSES
} from "../actions/types";

export default function(state = { plans: {}, estimate: {}, transactions: [] }, action) {
  switch (action.type) {
    case FETCH_SUBSCRIPTIONS:
      _.forEach(action.payload.plans, connections => {
        _.forEach(connections, connection => {
          connection.visible = true;
        });
      });
      return {
        ...state,
        ...action.payload // plans: ...
      };
    case FETCH_SUBSCRIPTION_ESTIMATE:
    case FETCH_SUBSCRIPTION_PAYMENT_INTENT:
    case FETCH_SUBSCRIPTION_ADDONS:
    case CLEAR_SUBSCRIPTION_ESTIMATE:
    case FETCH_LICENSES:
      return {
        ...state,
        ...action.payload // estimate: ... | addons: .... | ...
      };
    case FETCH_SUBSCRIPTION_CREATE:
      return {
        ...state,
        transactions: [...state.transactions, action.payload.transaction], // estimate: ...
        transaction: action.payload.transaction
      };
    case CLEAR_SUBSCRIPTION_CREATE:
      return {
        ...state,
        transaction: undefined
      };
    case CLEAR_LICENSES_INFO:
      return {
        ...state,
        license: undefined
      };

    default:
      return state;
  }
}
